<template lang="pug">
v-navigation-drawer(app, permanent, :value="$auth.check()")
  template(v-slot:prepend)
    .d-flex.justify-center
      .img
        v-img(src="@/assets/nbnb.jpg", transition="scale-transition", contain)
    v-divider
  template(v-slot:append, v-if="user")
    v-divider
    v-list-item(two-line)
      v-list-item-avatar(color="indigo")
        span.white--text.headline(v-html="user.first_name[0]")
      v-list-item-content
        v-list-item-title {{ user.first_name }} {{ user.last_name }}
        v-list-item-subtitle {{ user.email }}
      v-list-item-action
        v-menu(open-on-hover, top)
          template(v-slot:activator="{ on }")
            v-btn(v-on="on", icon)
              v-icon(color="grey lighten-1") mdi-account-settings
          v-list
            v-list-item(to="/account")
              v-list-item-title Account
            v-list-item(@click="logout")
              v-list-item-title.red--text Logout

  v-list(dense)
    //- v-if="item.show !== false"
    v-list-item(
      v-for="item in items.filter((el) => el.show !== false)",
      :key="item.title",
      :to="item.to"
    )
      v-list-item-icon
        v-icon {{ item.icon }}
      v-list-item-content
        v-list-item-title {{ item.title }}
</template>

<script>
import { isProduction } from '@/utils/environments.js'

export default {
  async mounted() {
    if (this.$auth.check()) {
      await Promise.all([
        await this.$store.dispatch("flows/refreshFlowsList"),
      ]).finally(() => {
        // console.log(this.$auth.user());
        const token = this.$auth.token();
        if (token) {
          const url = "ws://localhost:5000/api/v1/notifications/" + token;
          const ws = new WebSocket(url);
          ws.onmessage = (e) => {
            this.$message.info(e.data);
          };
        }
      });
    }
    if (isProduction()) {
      this.$intercom.boot({
        user_id: this.user.ID,
        name: `${this.user.first_name} ${this.user.last_name}`,
        email: this.user.email,
        created_at: this.toTimestamp(this.user.CreatedAt)
      });
    }
    if (this.$auth.check("lawyer")) {
      this.$store.dispatch("getCompanies");
    }
  },

  methods: {
    logout() {
      if (isProduction()) {
        this.$intercom.shutdown();
      }
      this.$store.dispatch("beforeLogout");
      this.$nextTick(() => {
        this.$auth.logout({ redirect: "/login" });
      });
    },

    toTimestamp(date) {
      return Math.round((new Date(date)).getTime() / 1000)
    }
  },

  computed: {
    userflow() {
      return this.$store.getters.freeCompany;
    },

    isAdmin() {
      return this.$auth.check("admin");
    },

    isEmployer() {
      return this.$auth.check("employer");
    },

    isLawyer() {
      return this.$auth.check("lawyer");
    },

    isExpert() {
      return this.$auth.check("expert");
    },

    isCandidate() {
      return this.$auth.check("candidate");
    },

    isNotAdmin() {
      return !this.isAdmin;
    },

    isEmployerWithCreatedCompany() {
      // return this.isEmployer && this.userflow && this.userflow.status !== 'in progress'
      return this.isEmployer;
    },

    items() {
      return [
        // { title: 'Dashboard', icon: 'mdi-view-dashboard-outline', to: '/' },
        {
          title: "Users",
          icon: "mdi-face",
          to: "/users",
          show: this.isAdmin,
        },
        {
          title: "Companies",
          icon: "mdi-office-building",
          to: "/companies",
          show: this.isAdmin,
        },
        {
          title: "Company profile",
          icon: "mdi-office-building",
          to: "/company",
          show: this.isEmployerWithCreatedCompany,
        },
        {
          title: "Cases",
          icon: "mdi-briefcase",
          to: "/cases",
          show: this.isEmployerWithCreatedCompany,
        },
        {
          title: "Cases",
          icon: "mdi-briefcase",
          to: "/lawyer/cases",
          show: this.isLawyer,
        },
        {
          title: "Cases",
          icon: "mdi-briefcase",
          to: "/expert/cases",
          show: this.isExpert,
        },
        // { title: 'Documents', icon: 'mdi-file-cabinet', to: '/documents', show: this.isNotAdmin },
        {
          title: "Case Documents",
          icon: "mdi-file-document-edit",
          to: "/case_documents",
          show: this.isAdmin,
        },
        {
          title: "Promocodes",
          icon: "mdi-sale",
          to: "/promo_codes",
          show: this.isAdmin,
        },
        {
          title: "Flows",
          icon: "mdi-chart-sankey-variant",
          to: "/flows",
          show: this.isAdmin,
        },
        {
          title: "Userflows",
          icon: "mdi-chart-sankey-variant",
          to: "/userflows",
          show: this.isAdmin,
        },
        {
          title: "Online Application",
          icon: "mdi-file-document",
          to: "/online-application",
          show: this.isAdmin,
        },
        {
          title: "Profile",
          icon: "mdi-face",
          to: "/profile",
          show: this.isCandidate,
        },
      ];
    },

    user() {
      return this.$auth.user();
    },
  },
};
</script>

<style lang="sass" scoped>
.img
  width: 200px
</style>
